module.exports = __webpack_public_path__ + "assets/img/Enginio_logotype_horizontal_blk.6df6f30c.png";